import { Subject } from 'rxjs';
import { settingService } from './service';

export class SettingStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.subject = new Subject();
  }

  async getPushStatus() {
    return settingService.getPushStatus();
  }

  async postAppReview(reviewInfo) {
    return settingService.postAppReview(reviewInfo);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/settingStore/index.js